import DefaultPlayer from './defaultPlayer'
import * as shaka from "shaka-player/dist/shaka-player.compiled.js"

const muxjs = require("mux.js/dist/mux.min.js") // for hls

/**
 * create player with shaka-player.js
 * extends default html5 player
 * @export
 */
export default class ShakaPlayer extends DefaultPlayer {
  constructor(mediaElement, manifestUrl) {
    super(mediaElement, manifestUrl)
    
    this.playerName_ = "Shaka-Player"

    /** @private */
    this.defaultConfig_ = {}
    this.shakaConfig_ = {}

    this.retryCount_ = 0

  }
  
  /** @override */
  initialize() {
    if (shaka.Player.isBrowserSupported()) {
      shaka.polyfill.installAll()
      
      shaka.media.ManifestParser.registerParserByExtension("m3u8", shaka.hls.HlsParser)
      shaka.media.ManifestParser.registerParserByMime("application/vnd.apple.mpegurl", shaka.hls.HlsParser)
      shaka.media.ManifestParser.registerParserByMime("application/x-mpegURL", shaka.hls.HlsParser)
      shaka.media.ManifestParser.registerParserByMime("application/dash+xml", shaka.dash.DashParser)
      
      this.player_ = new shaka.Player(this.mediaElement_)
      window.muxjs = muxjs
      
      this.player_.configure(this.shakaConfig_)
      this.player_.addEventListener('error', this.onError)
      this.player_.setMaxHardwareResolution(1920, 1080) // 하드웨어 해상도 수동 지정
      this.player_.getNetworkingEngine().registerRequestFilter(function(type, request) { // promise
          // TYPE VALUE = {0: MANIFEST, 1: SEGMENT, 2: LICENSE, 3: APP, 4: TIMING}
          // if (type != shaka.net.NetworkingEngine.RequestType.LICENSE) returnonfig_.widevine)
          if (type == 0) {
            // console.log("GET MANIFEST", request)
            // request.uris.push(request.uris[0].replace("chunklist_dvr.m3u8", "chunklist.m3u8"))
          } else if (type == 2 && this.defaultConfig_['widevine']) {
            let selectedDrmInfo = this.player_.drmInfo()
            // 브라우저 keysystem의 widevine 지원여부 체크
          if (selectedDrmInfo.keySystem == "com.widevine.alpha") {
            // 브라이트코브 licenseServer의 Token 값
            request.uris[0] += `?token=${this.defaultConfig_['widevine']['token']}`
          } else {
            console.error("Browser keysystem not found")
          }
        }
      }.bind(this)) 
    } else {
      console.error('Browser not supported!')
    }
  }
  
  /** @override */
  configure(defaultConfig) {
    console.log("configure with shaka player")
    let shakaConfig = this.advanceConfig_()

    if (defaultConfig['widevine']['licenseUrl']) {
      shakaConfig['drm'] = {
        servers: { 'com.widevine.alpha': defaultConfig['widevine']['licenseUrl'] },
        advanced: {
          'com.widevine.alpha': {
            'videoRobustness': 'SW_SECURE_CRYPTO', 
            'audioRobustness': 'SW_SECURE_CRYPTO' 
          }
        }
      }
    }

    this.shakaConfig_ = shakaConfig
    this.defaultConfig_ = defaultConfig

    this.initialize()
  }

  /** @private */
  advanceConfig_() {
    
    const abrManager = { // ABR 평균 비트레이트 자동 적응 매니저
      enabled: true,
      defaultBandwidthEstimate: (4<<20), // 시작 bandwidth 설정 (4194304)  브라이트코브 1080의 bandwidth가 약 4200000 
      switchInterval: 3, // default: 8 bandwidth 변경 스위칭 최소 경과 시간
    }, streamConfig = { // 스트리밍 설정
      retryParameters: {
        timeout: 5000, //재 요청 타임아웃 기본값(0) 설정하지 않으면 Samsung TV에서 세그먼트를 못찾아서 계속 재시도 함
        maxAttempts: 16, 
        baseDelay: 3500, //재시도 딜레이 (2s)
        backoffFactor: 2,
        fuzzFactor: 0.2 // -0.2*딜레이(1.5s) ~ 1.2*딜레이(1.5s) 사이에서 발생하도록 설정
      },
      rebufferingGoal: 1, // 재생 시작 전이나,버퍼링 상태에서 가져올 컨텐츠 시간 (초) // manifest minBufferTime
      bufferingGoal: 60, // 재생 해드보다 먼저 버퍼링을 시도하는 컨텐츠 시간
      bufferBehind: 30,  // 재생 헤드 뒤의 버퍼에 보관할 콘텐츠 최대 시간
      ignoreTextStreamFailures: true, // 텍스트 스트림 실패 무시
      startAtSegmentBoundary: false, // 시작 시간 강제 조정
      smallGapLimit: 2, // 무시할만한 미디어의 최소 간격 // 최소 세그먼트 길이
      jumpLargeGaps: true, // 큰 간격 건너 뛸 수 있는지 여부 // 플레이어 이벤트 발생 할 때 건너 뛸 간격
      // durationBackoff: 6,
      safeSeekOffset: 6, // 재생 해드 재배치 시 요청할 콘텐츠 시간 default:5
      inaccurateManifestTolerance: 0, // 탐색 전 메니페스트 오차 범위 지정
      startAtSegmentBoundary: true,
      stallEnabled: false, // stalling handle
      stallThreshold: 6,
      stallSkip: 6
    }, manifestConfig = { // 메니페스트 설정
      availabilityWindowOverride : this.defaultConfig_.isDvr ? 14400 : 18,   //timeShiftBufferDepth 강제 조정 (브라이트코브 18s)
      defaultPresentationDelay: 12, //* 메니페스트 timeShiftBufferDepth와 결합되는 속성 (기본값 0 = 1.5*minbufferTime) (브라이트코브 12s) suggestDelay
      dash: {
        clockSyncUri: "https://time.akamai.com/?iso&amp;ms", // 브라이트코브의 manifast <UTCTiming> 값과 동일하게 지정
        initialSegmentLimit: 3,
        ignoreSuggestedPresentationDelay: true,
        ignoreMinBufferTime: true // manifast에서 minbufferTime 속성 무시 (rebuffergoal 사용하기 위함)
      }
    }, retryParameters = {
      timeout: 5000,
      maxAttempts: 1,
      baseDelay: 4000, // 브라이트코브 manifast의 최소 업데이트 기간 minimumUpdatePeriod = 3초만큼 딜레이 가능
      backoffFactor: 2,
      fuzzFactor: 0.5
    }, restrictions = {
      minBandwidth: (4<<20), // 해상도 조정 시 최소 bandwidth, abrmanager enable: false} 일시 작동안함
      minPixels: (1920 * 1080),
      minHeight: 1080,
      minWidth: 1920
    }

    return { 
      // playRangeStart: 0,
      restrictions,
      abr: Object.assign(abrManager, {restrictions}),
      streaming: Object.assign(streamConfig, {failureCallback: this.onStreamingError_}),
      manifest: Object.assign(manifestConfig, {retryParameters})
    }
  }

  /** @private */
  onStreamingError_(err) {
    // custom stall handler
    // todo convert to async function
    console.log("onStreamingError", err)
    if (this.player_.isLive() && this.retryCount < 2){
      if (this.player_.isBuffering) {
        this.player_.retryStreaming()
      } else if(this.player_.getMediaElement().paused) {
        this.player_.getMediaElement().play()
      }
    } else if (this.retryCount == 3) {
      this.player_.unload().then(() => this.player_.load()).bind(this)
    } else {
      this.player_.destroy()
      return
    }
    this.retryCount ++
  }

  /** @override */
  seekRange() {
    // seekRange obj has property { start, end }
    return this.player_.seekRange()
  }

  /** @override */
  detach() {
    this.player_.detach()
  }

  /** @override */
  async load() {
    await this.player_.load(this.manifestUrl_)
  }

  /** @override */
  async destroy() {
    super.destroy()
  }

  /** 
   * @private Get time of infomations from media track
   * @param {Object} player - The current video player
   * @returns {Object}
  */
  getTracks = (player) => {
    const video = player.getMediaElement()

    if (!video) return

    const currentTime = video.currentTime || 0
    const bufferedLength = video.buffered.length
    const bufferedStart = bufferedLength ? video.buffered.start(0) : 0
    const bufferedEnd = bufferedLength ? video.buffered.end(bufferedLength - 1) : 0

    const seekRange = player.seekRange()
    const seekRangeSize = seekRange.end - seekRange.start

    const clampedBufferStart = Math.max(bufferedStart, seekRange.start)
    const clampedBufferEnd = Math.min(bufferedEnd, seekRange.end)
    const clampedCurrentTime = Math.min(Math.max(currentTime, seekRange.start), seekRange.end)

    const bufferStartDistance = clampedBufferStart - seekRange.start
    const bufferEndDistance = clampedBufferEnd - seekRange.start
    const playheadDistance = clampedCurrentTime - seekRange.start

    const bufferStartFraction = (bufferStartDistance / seekRangeSize) || 0
    const bufferEndFraction = (bufferEndDistance / seekRangeSize) || 0
    const playheadFraction = (playheadDistance / seekRangeSize) || 0

    return {
      clampedBufferStart,
      clampedBufferEnd,
      clampedCurrentTime,
      bufferStartFraction, 
      bufferEndFraction, 
      playheadFraction
    }
  }
}